import React from 'react';
import { adminProductApi } from '../../../../api/adminProductApi';
import { extractApiArray } from '../../../../utils/apiResponse';
import { formatMoney } from './mobileProductUtils';
import useMobileResource from './useMobileResource';
import MobileProductFeedback from './MobileProductFeedback';

export default function MobileProductVariants({ product, onEdit, onCreate, busy }) {
  const variants = useMobileResource(
    () => adminProductApi.getInnerProducts(product.id).then(extractApiArray),
    product.id,
  );
  return (
    <section>
      <h3>Дочірні товари</h3>
      <MobileProductFeedback
        loading={variants.loading}
        error={variants.error}
        onRetry={variants.reload}
      />
      {variants.data.map(variant => (
        <article key={variant.id} className='mp-variant'>
          <strong>
            #{variant.id} · {variant.name}
          </strong>
          <p>
            {variant.quantity} шт. · {formatMoney(variant.price)}
          </p>
          <button
            type='button'
            className='btn btn-outline-dark'
            disabled={busy}
            onClick={() => onEdit(variant)}
          >
            Редагувати
          </button>
        </article>
      ))}
      {!variants.loading && !variants.error && !variants.data.length && (
        <p className='mp-note'>Дочірніх товарів поки немає.</p>
      )}
      <button type='button' className='btn btn-dark' disabled={busy} onClick={onCreate}>
        + Дочірній товар
      </button>
    </section>
  );
}
